/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Zoom_InInputs */

const en_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in`)
};

const ar_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكبير`)
};

const bn_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জুম ইন`)
};

const de_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößern`)
};

const es_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acercar`)
};

const fr_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom avant`)
};

const pt_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproximar`)
};

const zh_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大`)
};

const tr_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakınlaştır`)
};

const ru_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить`)
};

const pl_image_inspector_zoom_in = /** @type {(inputs: Image_Inspector_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przybliż`)
};

/**
* | output |
* | --- |
* | "Zoom in" |
*
* @param {Image_Inspector_Zoom_InInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_zoom_in = /** @type {((inputs?: Image_Inspector_Zoom_InInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Zoom_InInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_zoom_in(inputs)
	if (locale === "bn") return bn_image_inspector_zoom_in(inputs)
	if (locale === "de") return de_image_inspector_zoom_in(inputs)
	if (locale === "es") return es_image_inspector_zoom_in(inputs)
	if (locale === "fr") return fr_image_inspector_zoom_in(inputs)
	if (locale === "pt") return pt_image_inspector_zoom_in(inputs)
	if (locale === "zh") return zh_image_inspector_zoom_in(inputs)
	if (locale === "tr") return tr_image_inspector_zoom_in(inputs)
	if (locale === "ru") return ru_image_inspector_zoom_in(inputs)
	if (locale === "pl") return pl_image_inspector_zoom_in(inputs)
	return en_image_inspector_zoom_in(inputs)
});